'use client';
import React from 'react';

interface BackButtonProps {
	onGoBack: () => void;
	text: string;
}

export default function BackButton({ onGoBack, text }: BackButtonProps) {
	return (
		<button className="back-to-resources-list" onClick={onGoBack}>
			{text}
		</button>
	);
}
